export default __webpack_public_path__ + "static/media/nodata.d7d25263.jpg";